module.exports = __webpack_public_path__ + "static/img/common.15e1365e.png";